import * as React from 'react';
import styled from 'styled-components';
import { getUserScores, UserScore } from '../../../atoms/calculatedFields';
import { BorderColor, DarkGreySidely2, GreySidely4 } from '../../../styles/global/css/Utils';
import { Translate, translateToString } from '../../../styles/global/translate';

const Block = styled.div`
	display: flex;
	flex-flow: column;
	gap: 8px;
	width: 100%;
	padding: 10px 12px;
	border: 1px solid ${BorderColor};
	border-radius: 5px;
`;

const Title = styled.h5`
	margin: 0;
	font-size: 12px;
	font-weight: 500;
	color: ${GreySidely4};
`;

const Row = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	gap: 10px;
	font-size: 13px;
	color: ${DarkGreySidely2};
`;

const Figure = styled.span`
	font-weight: 600;
`;

const Aside = styled.span`
	font-size: 11px;
	color: ${GreySidely4};
`;

function round(value: number): string {
	return (Math.round(value * 10) / 10).toString();
}

/// A rep's reading of each scorecard: the mean of the stores they own, beside
/// the points those stores earned together. Renders nothing at all when the
/// tenant has no scorecard, which is most of them.
export default function UserScores(props: { userId: number }): JSX.Element {
	const [scores, setScores] = React.useState<UserScore[]>([]);

	React.useEffect(() => {
		getUserScores(props.userId).then(setScores).catch(console.error);
	}, [props.userId]);

	if (scores.length === 0) return <></>;
	return <Block>
		<Title><Translate id='score.user_title' /></Title>
		{scores.map(score => <Row key={`user_score[${score.field_id}]`}>
			<span>{score.field_name}</span>
			<span>
				<Figure>{score.score === null ? translateToString('score.not_scored') : `${round(score.score)} / 100`}</Figure>
				{' '}
				<Aside>
					{round(score.earned)} / {round(score.earnable)}
					{' · '}
					{translateToString('score.stores_counted', [['COUNT', score.scored_companies.toString()]])}
				</Aside>
			</span>
		</Row>)}
	</Block>;
}
